import { Power2 } from 'gsap';

import DraggablePreset from './DraggablePreset';
import TextBlock from '../../graphics/TextBlock';
import { getCenterX, getCenterY } from '../../utils/CoordinateCalculator';

const MAX_DURATION = 2;
const STAGGER_SLIDE_RATIO = 1 / 4;

const DOWN = 'DOWN';
const LEFT = 'LEFT';
const RIGHT = 'RIGHT';
const UP = 'UP';
export const SwipeDirections = {
  DOWN,
  LEFT,
  RIGHT,
  UP,
};

export default class Swipe extends DraggablePreset {
  constructor(app, options = { animationDirection: UP }) {
    super(app);

    this.animationDirection = options.animationDirection;
    this.textBlock = new TextBlock(app);
    this.container.addChild(this.textBlock);
  }

  calculateAnimationTimings(numLines) {
    const halfDuration = Math.min(this.duration, MAX_DURATION) / 2;

    // lineStagger/slideDuration = STAGGER_SLIDE_RATIO
    // lineStagger*(numLines -1) + slideDuration = halfDuration
    const slideDuration =
      halfDuration / (STAGGER_SLIDE_RATIO * (numLines - 1) + 1);
    const lineStagger = STAGGER_SLIDE_RATIO * slideDuration;

    return {
      slideDuration,
      lineStagger,
    };
  }

  getLineStartPosition(line) {
    const position = {
      startX: line.x,
      startY: line.y,
    };

    switch (this.animationDirection) {
      case DOWN:
        position.startY -= line.lineHeight;
        break;
      case LEFT:
        position.startX += line.lineHeight;
        break;
      case RIGHT:
        position.startX -= line.lineHeight;
        break;
      case UP:
        position.startY += line.lineHeight;
        break;
    }

    return position;
  }

  update(model) {
    super.update(model);

    const animationTimings = this.calculateAnimationTimings(this.numTextLines);

    this.textBlock.updateTextAndStyle(model.text, model);
    this.setDraggableRoot(
      this.textBlock.blockHeight,
      this.textBlock.blockWidth
    );
    this.textBlock.x = getCenterX(
      { width: this.textBlock.blockWidth },
      this.root
    );
    this.textBlock.y = getCenterY(
      { height: this.textBlock.blockHeight },
      this.root
    );

    this.textBlock.lines.forEach((line, index) => {
      const originalPosition = {
        x: line.x,
        y: line.y,
      };

      const { startX, startY } = this.getLineStartPosition(line);
      line.x = startX;
      line.y = startY;
      line.alpha = 0;

      this.animate(line)
        .to(
          {
            alpha: 1,
            duration: animationTimings.slideDuration,
            ease: Power2.easeOut,
            x: originalPosition.x,
            y: originalPosition.y,
          },
          animationTimings.lineStagger * index
        )
        .reverseOut();
    });
  }
}
